import script from "./Pre-Sla-Requirements-Agreement.vue?vue&type=script&setup=true&lang=js"
export * from "./Pre-Sla-Requirements-Agreement.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__